import { queryOptions, useQuery } from "@tanstack/react-query";

import { type HealthReport, healthApi } from "@/api";
import { QUERY_KEYS } from "@/constants";
import type { ApiResponse } from "@/types";

/** Avtomatik tekshiruv oralig'i. Sahifa ham shu raqamni ko'rsatadi. */
export const HEALTH_REFRESH_MS = 15_000;

/** Bitta tekshiruv: backend hisoboti va brauzerdan o'lchangan javob vaqti. */
export interface HealthCheck {
  report: HealthReport;
  /** So'rov ketgandan javob kelguncha o'tgan vaqt, ms. */
  latencyMs: number;
}

type TimedHealth = ApiResponse<HealthReport> & { latencyMs: number };

// Javob vaqtini backend bermaydi, shuning uchun u shu yerda o'lchanadi.
// "Server tirik, lekin sekin" ham signal: health endpoint bazani, Redis'ni
// va MinIO'ni so'raydi — ulardan biri qiynalsa, javob kechikadi.
const fetchHealth = async (): Promise<TimedHealth> => {
  const started = performance.now();
  const res = await healthApi.getHealth();
  return { ...res, latencyMs: Math.round(performance.now() - started) };
};

// Ikkala hook bitta kesh yozuvini bo'lishadi: boshqaruv paneli va tizim
// holati sahifasi bir-biriga qo'shimcha so'rov yubormaydi.
const healthQuery = queryOptions({
  queryKey: [QUERY_KEYS.GET_HEALTH],
  queryFn: fetchHealth,
  // O'zi yangilanadi — admin sahifani qayta yuklamasdan jonli holatni ko'radi.
  refetchInterval: HEALTH_REFRESH_MS,
});

// `select` modul darajasida: har render'da yangi funksiya bo'lsa, natija
// ham har safar yangi obyekt bo'lib, uni kuzatadigan hamma narsa qayta
// hisoblanardi.
const toReport = (res: TimedHealth): HealthReport => res.data;
const toCheck = (res: TimedHealth): HealthCheck => ({ report: res.data, latencyMs: res.latencyMs });

export const useHealth = () => useQuery({ ...healthQuery, select: toReport });

/** Tizim holati sahifasi uchun: hisobot + javob vaqti. */
export const useHealthCheck = () => useQuery({ ...healthQuery, select: toCheck });
